import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import axios from 'axios'
Vue.use(ElementUI, { size: 'mini', zIndex: 3000 });

Vue.config.productionTip = false


let baseURL= '/'
//let baseURL= 'https://v009.qpzt.net'
let instance = axios.create({
    baseURL: baseURL,
    timeout: 600000, 
})

// 配置请求拦截
instance.interceptors.request.use((config) => {
    // 添加token
    config.headers["token"] =localStorage.getItem('userToken') || '';
    return config;
},
    (error) => {
        console.log(error);
        alert('发送请求失败')
    }
)

instance.interceptors.response.use(res => {
    return res
}, err => {
    return Promise.reject(err)
})


Vue.prototype.$post=function(url, params) {
    return new Promise((resolve, reject) => {
        instance.post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

//添加一个全局变量
Vue.prototype.GLOBAL = {
  FIND_PIC:{
        "type": "找图",
        "running": false,
        "remark": "",
        "showLog": true,
        "showSquare": false,
        "taskConfig": {
            "similarity": 85,
            "reminderTiming": 0,
            "isFull": 0,
            "checkRate": 5,
            "ignore": "",
            "regText": "",
            "timeSet":"默认班次",
        },
        "remindConfig": {
            "taskSound": "music\\default1.wav",
            "ringRate": 3,
            "telRate": 600,
            "wechatRate": 300,
            "workChatRate": 30,
            "personList": [
                {
                    "name": "当前用户",
                    "useTel": true,
                    "useWechat": true,
                    "useWorkChat": true
                }
            ]
        },
        "advancedConfig": {
            "callBackUrl": "",
            "userParam": "",
            "callBackTakeRemind": 0,
            "useMouse": 0,
            "positionType": 0,
            "offsetX": 0,
            "offsetY": 0,
            "uploadScreenShot": 0
        },
        "area": {
            "x": 400,
            "y": 400,
            "w": 300,
            "h": 300
        }
    },
  FIND_COLOR:{
        "type": "找色",
        "running": false,
        "remark": "",
        "showLog": true,
        "showSquare": false,
        "taskConfig": {
            "similarity": 0,
            "reminderTiming": 1,
            "checkRate": 5,
            "ignore": "",
            "regText": "",
            "blockHeight": 30,
            "blockWidth": 30,
            "targetColor": "",
            "timeSet":"默认班次"
        },
        "remindConfig": {
            "taskSound": "music\\default1.wav",
            "ringRate": 3,
            "telRate": 600,
            "wechatRate": 300,
            "workChatRate": 30,
            "personList": [
                {
                    "name": "当前用户",
                    "useTel": true,
                    "useWechat": true,
                    "useWorkChat": true
                }
            ]
        },
        "advancedConfig": {
            "callBackUrl": "",
            "userParam": "",
            "callBackTakeRemind": 0,
            "useMouse": 0,
            "positionType": 0,
            "offsetX": 0,
            "offsetY": 0,
            "uploadScreenShot": 0
        },
        "area": {
            "x": 400,
            "y": 400,
            "w": 300,
            "h": 300
        }
    },
  FIND_TEXT:{
        "type": "找字",
        "running": false,
        "remark": "",
        "showLog": true,
        "showSquare": false,
        "taskConfig": {
            "reminderTiming": 3,
            "checkRate": 4,
            "ignore": "",
            "regText": "",
            "targetText": "",
            "ocrServer": 0,
            "dataCount": 2,
            "timeSet":"默认班次"
        },
        "remindConfig": {
            "taskSound": "music\\default1.wav",
            "ringRate": 3,
            "telRate": 600,
            "wechatRate": 300,
            "workChatRate": 30,
            "personList": [
                {
                    "name": "当前用户",
                    "useTel": true,
                    "useWechat": true,
                    "useWorkChat": true
                }
            ]
        },
        "advancedConfig": {
            "callBackUrl": "",
            "userParam": "",
            "callBackTakeRemind": 0,
            "useMouse": 0,
            "positionType": 0,
            "offsetX": 0,
            "offsetY": 0,
            "uploadScreenShot": 0

        },
        "area": {
            "x": 400,
            "y": 400,
            "w": 300,
            "h": 300
        }
    },
    CHECK_CHANGE:{
        "type": "变化检测",
        "running": false,
        "remark": "",
        "showLog": true,
        "showSquare": false,
        "taskConfig": {
            "reminderTiming": 1,
            "checkRate": 4,
            "ignore": "",
            "diffRate": 0,
            "dataCount": 2,
            "timeSet":"默认班次"
        },
        "remindConfig": {
            "taskSound": "music\\default1.wav",
            "ringRate": 3,
            "telRate": 600,
            "wechatRate": 300,
            "workChatRate": 30,
            "personList": [
                {
                    "name": "当前用户",
                    "useTel": true,
                    "useWechat": true,
                    "useWorkChat": true
                }
            ]
        },
        "advancedConfig": {
            "callBackUrl": "",
            "userParam": "",
            "callBackTakeRemind": 0,
            "useMouse": 0,
            "positionType": 0,
            "offsetX": 0,
            "offsetY": 0,
            "uploadScreenShot": 0
        },
        "area": {
            "x": 400,
            "y": 400,
            "w": 300,
            "h": 300
        }
    },
    CLICK_TASK:{
        "type": "点击任务",
        "running": false,
        "remark": "",
        "showLog": true,
        "showSquare": false,
        "taskConfig": {
            "reminderTiming": 1,
            "checkRate": 4,
            "targetPos": "(100,100,1,1)",
            "ignore": "",
            "diffRate": 0,
            "dataCount": 2,
            "timeSet":"默认班次"
        },
        "remindConfig": {
            "taskSound": "music\\静音.wav",
            "ringRate": 3,
            "telRate": 600,
            "wechatRate": 300,
            "workChatRate": 30,
            "personList": [
                {
                    "name": "当前用户",
                    "useTel": false,
                    "useWechat": false,
                    "useWorkChat": false
                }
            ]
        },
        "advancedConfig": {
            "callBackUrl": "",
            "userParam": "",
            "callBackTakeRemind": 0,
            "useMouse": 0,
            "positionType": 0,
            "offsetX": 0,
            "offsetY": 0,
            "uploadScreenShot": 0
        },
        "area": {
            "x": 400,
            "y": 400,
            "w": 300,
            "h": 300
        }
    }


}

new Vue({
  render: h => h(App),
}).$mount('#app')
